<template>
  <div>
    <a class="backBtn" href="/#/">
      <img src="/img/back-icon.png" />
    </a>
    <div class="page-header header-filter">
      <div class="page-header-image spacecraft-background"
        :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`" />
      <div class="container spacecraft-container" v-if="!isShowingTask">
        <div class="row spacecraft-row">
          <div @click="goToBook" class="col-sm button-container books" style="background-color: cyan;
               margin-right: 3rem;
               margin-top: 3rem;
               transform:rotate(-10deg);">
            <img src="/img/botonLibro.png" width="100%" />
          </div>
          <!-- <div @click="goToActivity()" class="col-sm button-container activities"
               style="background-color: yellow;">
            <img src="/img/botonActividades.png" width="100%"/>
          </div> -->
          <div @click="goToResources" class="col-sm button-container resources" style="background-color: magenta;
               margin-left: 3rem;
               margin-top: 3rem;
               transform:rotate(10deg);">
            <img src="/img/botonRecursos.png" width="100%" />
          </div>
          <!-- <MatificButton style="background-color: yellow;" classes="col-sm button-container activities">
            <template v-slot:content>
              <img src="/img/botonActividades.png" width="100%"/>
            </template>
</MatificButton> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import { mapState } from 'vuex';
import { SlideYUpTransition, FadeTransition } from 'vue2-transitions';
import Video from './Video.vue';
import MatificButton from '../components/MatificButton.vue';

export default {
  name: 'mission',
  async created() {
    NProgress.done();
    this.init();
  },
  components: {
    SlideYUpTransition,
    FadeTransition,
    [Video.name]: Video,
    MatificButton
  },
  data() {
    return {
      isShowingTask: false,
      isShowingVideo: false,
      taskType: ''
    };
  },
  computed: {
    ...mapState({
      essentials: state => state.session.currentGrade.data.essentials,
    }),
    missionId() {
      return this.$route.params.missionId;
    }
  },
  methods: {
    init() {
      let e = localStorage.getItem('userGrade');
    },
    logout() {
      Auth.logout();
    },

    async goToBook() {
      const uuid = this.$route.params.userId || this.$store.state.session.currentUser.uuid;

      await this.$store.dispatch('session/getCurrentUser', uuid);
      const userRole = this.$store.state.session.currentUser.roles.find(element => element.role.code === "SUPER-ADMIN" || element.role.code === "TEACHER"
        || element.role.code === "DESIGN" || element.role.code === "DIRECTORIAL" || element.role.code === "ADMINISTRATIVE" || element.role.code === "SALES");

      if (userRole) {
        this.$router.push(`/mission/${this.missionId}/libro`);
        return;
      }

      const hasFitForEnglishEssentials = this.essentials.some(item => item.includes('Fit For English Essentials'));
      const hasMisionPrimaria = this.essentials.some(item => item.includes('Misión Primaria'));

      if (hasMisionPrimaria) {
        this.$router.push(`/mission/${this.missionId}/libro`);
      } else if (hasFitForEnglishEssentials) {
        this.$router.push(`/essential/mission/${this.missionId}/libro`);
      } else {
        alert('No tienes acceso a este libro.');
      }
    },
    
    goToActivity() {
      this.$router.push(`/mission/${this.missionId}/actividad`);
    },
    async goToResources() {

      const uuid = this.$route.params.userId || this.$store.state.session.currentUser.uuid;

      await this.$store.dispatch('session/getCurrentUser', uuid);
      const userRole = this.$store.state.session.currentUser.roles.find(element => element.role.code === "SUPER-ADMIN" || element.role.code === "TEACHER");
     

      if (userRole) {
        this.$router.push(`/mission/${this.missionId}/libro`);
        return;
      }
      const hasFitForEnglishEssentials = this.essentials.some(item => item.includes('Fit For English Essentials'));
      const hasMisionPrimaria = this.essentials.some(item => item.includes('Misión Primaria'));

      if (hasMisionPrimaria) {
        this.$router.push(`/mission/${this.missionId}/recursos`);
      } else if (hasFitForEnglishEssentials) {
        this.$router.push(`/essential/mission/${this.missionId}/recursos`);
      } else {
        alert('No tienes acceso a estos recursos.');
      }
    },
    selectTask(taskType) {
      this.isShowingTask = true;
      this.taskType = taskType;
    },
    clearTask() {
      if (this.isShowingVideo) {
        this.toggleVideo();
        return;
      }
      this.isShowingTask = false;
      this.taskType = '';
    },
    toggleVideo() {
      this.isShowingVideo = !this.isShowingVideo;
    },
    goToActivities(activityId) {
      this.$router.push(`/mission/${this.missionId}/activities/activity${activityId}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.backBtn {
  position: absolute;
  right: 55px;
  width: 55px;
  height: auto;
  z-index: 9999;

  img {
    width: 35px;
    height: 35px;
    margin: 7.5px;
  }
}

.spacecraft-background {
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}

.spacecraft-container {
  min-width: 100%;
  min-height: 100vh;
  padding-top: 0rem;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  justify-content: center;
}

.spacecraft-row {
  min-width: 70%;
  max-width: 70%;
  padding-top: 20vw;
  padding-left: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  background-color: darkslategray;
  cursor: pointer;
  border-width: 15px;
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  margin-top: 1rem;
  min-height: 10rem;
  min-width: 15rem;
  max-width: 16rem;
  max-height: 11rem;
  border-radius: 1.5rem;
  border-top-left-radius: 3.5rem;
  border-top-right-radius: 3.5rem;
  background-position: 50% 50%;
  box-shadow: -1vw .5vw 1vw rgba(0, 0, 0, .3);

  &.books:hover {
    transform: scale(1.1) rotate(-10deg) !important;
  }

  &.activities:hover {
    transform: scale(1.1) rotate(0deg) !important;
  }

  &.resources:hover {
    transform: scale(1.1) rotate(10deg) !important;
  }
}

.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  padding-top: 0% !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraftGlass.png');
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: start;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 80vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

@media (max-width: 1230px) {
  .button-container {
    transform: rotate(0deg) !important;
    margin-top: 1rem !important;
  }

  .spacecraft-row {
    padding-left: 0rem !important;
  }
}
</style>
